import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class DeviceFormatHelperService {
    SIZE_MOBILE_WITDH = 768;
    mobileFormatClassName = 'is-mobile';
    desktopFormatClassName = 'is-desktop';
  }
